'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var GTM_CATEGORY = 'v2-bib-format-chooser';

var GTM_INTERACTION_ACTION = 'v2-container-interaction';
var GTM_LINK_CLICK_ACTION = 'v2-link-click';

var GTM_VIEW_ALL_LABEL = 'all-results';
var GTM_EXPAND_LABEL = 'expand';
var GTM_COLLAPSE_LABEL = 'collapse';

var GTM_EVENT_NAME = 'bc.bibFormatChooserSelection';

function composeFormatPickerExpandEvent(expand) {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
    gtmCategory: GTM_CATEGORY,
    gtmAction: GTM_INTERACTION_ACTION,
    gtmLabel: expand ? GTM_EXPAND_LABEL : GTM_COLLAPSE_LABEL,
    gtmValue: 1
  })]);
}

function composeFormatPickerSelectionEvent(label) {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
    gtmCategory: GTM_CATEGORY,
    gtmAction: GTM_LINK_CLICK_ACTION,
    gtmLabel: label,
    gtmValue: 1
  })]);
}

function composeFormatPickerViewAllEvent() {
  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
    gtmCategory: GTM_CATEGORY,
    gtmAction: GTM_INTERACTION_ACTION,
    gtmLabel: GTM_VIEW_ALL_LABEL,
    gtmValue: 1
  })]);
}

exports.default = {
  composeFormatPickerExpandEvent: composeFormatPickerExpandEvent,
  composeFormatPickerSelectionEvent: composeFormatPickerSelectionEvent,
  composeFormatPickerViewAllEvent: composeFormatPickerViewAllEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/bibFormatChooser.js
// module id = 549
// module chunks = 0 2 4 6 7 8 9 10